export const teamTypeValues = [
    "amhp",
    "mha",
    "ward",
    "independent",
    // MCA/DoLS governance teams: hold grants over care home registers and work
    // from the register rather than a caseload
    "mca",
    "guest",
    "generic",
    // We keep these separate even though 'soad' is
    // basically like an 'independent' team and 'cqc' is like a 'mha' team
    // because there may be specific pages/rules for them in the future
    "soad",
    "cqc",
    // Payment reviewer teams have read-only access to S12 payment requests
    // scoped to their assigned local authorities
    "section-12-payment-reviewers",
];
//# sourceMappingURL=teams.js.map